export const OBJECTIVE_VALUES_MAP = {
  PERFORMANCE: 'performance',
  AWARENESS: 'awareness',
  PERFORMANCE_AND_AWARENESS: 'all',
};

export const OBJECTIVE_OPTIONS = [
  { value: OBJECTIVE_VALUES_MAP.AWARENESS, displayName: 'Awareness' },
  { value: OBJECTIVE_VALUES_MAP.PERFORMANCE, displayName: 'Performance' },
  {
    value: OBJECTIVE_VALUES_MAP.PERFORMANCE_AND_AWARENESS,
    displayName: 'Performance & Awareness',
  },
];

export const TYPE_OF_BUYING = [
  { value: 'Open market RTB', displayName: 'Open market RTB' },
  { value: 'PMP/RTB', displayName: 'PMP/RTB' },
  { value: 'Programmatic guaranteed', displayName: 'Programmatic guaranteed' },
  { value: 'Reservation', displayName: 'Reservation' },
];

export default {
  OBJECTIVE_VALUES_MAP,
  OBJECTIVE_OPTIONS,
};
